import { Navigate, useLocation } from 'react-router-dom'
import { useDeploymentMode } from '../contexts/DeploymentModeContext'

interface RequireSelfManagedProps {
  children: React.ReactNode
  /** Override the default /403 redirect target (rare). */
  redirectTo?: string
}

/**
 * Route guard for customer-operated surfaces — currently the file-key license
 * page. The vendor SaaS manages org keys per health system instead, so a
 * file-key page there would show a meaningless evaluation countdown; direct
 * navigation is blocked — the route-level complement to the nav-level
 * `selfManagedOnly` gate. Waits for the deployment-mode fetch before
 * deciding; fail-closed once resolved.
 */
export default function RequireSelfManaged({ children, redirectTo = '/403' }: RequireSelfManagedProps) {
  const { showFileKeyLicensing, isLoading } = useDeploymentMode()
  const location = useLocation()

  if (isLoading) return null

  if (!showFileKeyLicensing) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{ attemptedPath: location.pathname, reason: 'self-managed-only' }}
      />
    )
  }

  return <>{children}</>
}
